module.exports = {
      id: "minfinLogo-usage",
      viewBox: "0 0 109 33",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#minfinLogo-usage",
      toString: function () {
        return this.url;
      }
    }